<template>
  <div class="shoppingCart">
    <div class="layer">
      <Search title="请输入" subheading="购物车" />
    </div>
    <div class="container" id="container">
      <div class="cartContent">
        <div class="top">
          <div class="left">
            <div class="allgoods">
              全部商品 <span class="colorRed">{{cartList.length}}</span>
            </div>
          </div>
          <div class="right">
            已选择商品（不包含运费）
            <label class="amount">￥ {{ totalSum.toFixed(2) }}</label>
            <el-button :disabled="checkedCommdity.length===0" class="submitBtn" :size="'mini'" type="danger" @click="gotoPayment()">结算</el-button>
          </div>
        </div>
        <div class="content">
			<el-table :data="cartList" @selection-change="changeChecked" ref="table" max-height="710">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column label="商品信息">
					<template slot-scope="scope">
						<div><img style="height: 55px;width: 88px;object-fit: contain;cursor: pointer" :src="scope.row.original_img" @click="gotoDetail(scope.row)" /></div>
						<div @click="gotoDetail(scope.row)" style="cursor: pointer">
						<div>{{ scope.row.common_name }}<span v-if="scope.row.goods_name!==''">({{ scope.row.goods_name }})</span></div>
						<div>{{scope.row.goods_spec}}</div>
						<div>{{scope.row.manufacturer}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="单价">
					<template slot-scope="scope">
						￥{{ scope.row.pay_price }}
					</template>
				</el-table-column>
				<el-table-column label="数量">
					<template slot-scope="scope">
						<el-input-number v-model="scope.row.goods_num" size="mini" :min="1" :max="99" @change="changeAmount(scope.row)"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column label="金额">
					<template slot-scope="scope"  >
						￥{{ (scope.row.pay_price * scope.row.goods_num).toFixed(2) }}
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<div style="display: flex;flex-direction: column;cursor: pointer;">
						<div @click="addCollect(scope.row.goods_id)">加入收藏</div>
						<div @click="delectSelf(scope.row.id)">删除</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
        </div>
        <div class="bottom">
          <div class="left bottomLeft">
            <div class="allgoods ">
              <el-checkbox v-model="checkAll" @change="checkedAll">全选</el-checkbox>
            </div>
            <div style="margin-left: 15px;cursor:pointer;" @click="delect()">
              删除
            </div>
          </div>
          <div class="right">
            已选择商品（不包含运费）
            <label class="amount">￥ {{ totalSum.toFixed(2) }}</label>
            <el-button :disabled="checkedCommdity.length===0" class="submitBtn" type="danger" @click="gotoPayment()">结算</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search/index'
import { GoodsService } from '../../service/goods.service'
import { MessageBox } from 'element-ui';

export default {
    name: 'shoppingCart',
    components: { Search },
    data() {
      return{
        checkAll: false,
        commdity: [],//全部药品列表
        cartList: [],
        checkedCommdity: [],//选中的商品ID
        totalSum: 0,//总金额
      }
	},
	created(){
		this.getList()
	},
    methods: {
		async getList() {
			const data = await GoodsService.getCartList()
			this.cartList = JSON.parse(JSON.stringify(data))
			this.cartList.forEach(val=>{
				val.original_img = GoodsService.thumbImg(val.original_img)
			})
		},
      async changeAmount(item) {//改变数量的时候计算金额
          this.mathTotalSum();

        await GoodsService.editCart(item.id,item.goods_num)
      },
      checkedAll() {//全选
        if(this.checkAll){
          this.cartList.forEach(item=>{
            this.$refs.table.toggleRowSelection(item)
          })
        }else{
          this.$refs.table.clearSelection()
        }
      },
      changeChecked(value) {//改变勾选
        this.totalSum = 0
        this.checkedCommdity=[]
        value.forEach(item=>{
          this.totalSum += item.pay_price*item.goods_num
          this.checkedCommdity.push(item.id)
        })
        if(value.length == this.cartList.length){
          this.checkAll = true
        }else{
          this.checkAll = false
        }
      },
      gotoDetail(val) {
         this.$router.push(`/goodDetail/${val.goods_id}`);
      },
      async delect() {
        await MessageBox.confirm('确定删除所选商品吗？');

        let StrCheckedCommdity = this.checkedCommdity.toString()
        await GoodsService.shoppingCartDel(StrCheckedCommdity)
        this.checkedCommdity.forEach(item=>{
          this.cartList = this.cartList.filter(it=>it.id !== item)
          this.commdity = this.commdity.filter(it=> it !== item)
        })
        this.checkedCommdity = []
        this.checkAll = false
        this.$store.commit('calculationNumber',this.commdity.length)
        this.totalSum = 0
        this.$message.success('删除成功！');
      },
      async addCollect(id) {//加入收藏
        GoodsService.addCollect(id).then(()=>{
          this.$message.success('添加成功')
        })
      },
      async delectSelf(id) {
        await MessageBox.confirm('确定从购物车删除该商品吗？');
        try{
          await GoodsService.shoppingCartDel(id)
          this.cartList = this.cartList.filter(it=>it.id !== id)
          this.checkedCommdity = this.checkedCommdity.filter(it=>it !== id)
          this.commdity = this.commdity.filter(it=> it !== id)
          let checkCount = this.checkedCommdity.length
          this.checkAll = checkCount === this.commdity.length
          this.mathTotalSum()
          this.$store.commit('calculationNumber',this.commdity.length)
          this.$message.success('删除成功！');
        }catch(e){
          console.log(e)
        }
      },
      mathTotalSum() {//计算总金额
        this.totalSum = 0
        for(let i in this.checkedCommdity){
          let myIndex = this.checkedCommdity[i]
          this.cartList.map((val)=>{
            if(val.id == myIndex){
              this.totalSum  = this.totalSum + val.goods_num*val.pay_price
            }
          })
        }
      },
      gotoPayment() {
        let cloneCartList = []
        this.checkedCommdity.forEach(item=>{
          cloneCartList.push(this.cartList.filter(it=>{return it.id == item})[0])
        })
        console.log(cloneCartList)
        this.$store.commit('addCartList',cloneCartList)
        this.$store.commit('calculationNumber',this.cartList.length - cloneCartList.length);
        this.$router.push('/order/order')
      }
    },
  }
</script>

<style lang="scss" scoped>
.shoppingCart {
  width: 100%;
}

.container {
  padding: 20px 0 80px;
  display: flex;
}

.cartContent {
	margin:0 auto;
	position: relative;
	display: flex;
	flex-direction: column;
	width: 1200px;
	.top {
		display: flex;
	}
	.content {
		display: flex;
		flex-direction: column;
		.drugItem {
			border-top: none;
		}
		.el-checkbox-group .drugItem:first-child {
			border-top: 1px solid #bab9b9;
		}
	}
	.bottom {
		margin-top: 20px;
		display: flex;
		align-items: center;
		background: #e5e5e5;
		height: 38px;
		padding-left: 20px;
		.right {
			border: none;
			padding: 0;
			.submitBtn {
				height: 38px;
				width: 80px;
			}
		}
		.left > div {
			border: none;
			padding: 0;
		}
		.bottomLeft {
			font-weight: 300;
			font-size: 15px;
		}
	}
}

.amount {
	color: red;
	font-weight: 600;
}

.left {
	font-size: 18px;
	font-weight: 600;
	display: flex;
	& > div {
		padding-bottom: 20px;
		border-bottom: 2px solid #bab9b9;
	}
}
.right {
	font-size: 13px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex: 1;
	border-bottom: 2px solid #bab9b9;
	padding-bottom: 20px;
}
.submitBtn {
	border-radius: 0 !important;
	height: 25px;
	width: 46px;
	margin-left: 10px !important;
	padding: 0 !important;
	font-size: 12px;
}
</style>
